import { useFrame } from '~/shared/utils/frame/hooks/useFrame';

export const useBrandId = () => {
	const { data: frame } = useFrame();
	return frame.vertical?.brandNo || 'none';
};
